import Image from 'next/image';
import React from 'react';
import FadeInAnimation from "../../Common/FadeInAnimation";
import { useTranslations } from '../../../locales/useTranslations';

const PowerBiHeader = () => {
    const { t } = useTranslations();
    return (
        <div className="mainbanner powerbi-header">
            {/* Subtile Hintergrund-Elemente */}
            <div className="powerbi-header__decoration powerbi-header__decoration--top-right"></div>
            <div className="powerbi-header__decoration powerbi-header__decoration--bottom-left"></div>

            <section className="services-area ptb-100 powerbi-header__content">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="services-content it-service-content">
                                <div className="content">
                                    <div className="powerbi-header__badge">
                                        {t('powerBi_upperHeader_title')}
                                    </div>

                                    <h1 className="powerbi-header__title">
                                        {t('powerBi_header_title')}
                                    </h1>

                                    <p className="powerbi-header__description">
                                        {t('powerBi_header_description')}
                                    </p>

                                    <p className="powerbi-header__description powerbi-header__description--secondary">
                                        {t('powerBi_header_description2')}
                                    </p>

                                    {/* CTA Button */}
                                    <a href="/kontakt" className="powerbi-header__cta">
                                        {t('powerBi_header_cta')}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <div className="services-image powerbi-header__image-wrapper">
                                <FadeInAnimation direction="right" delay={100}>
                                    <div className="image powerbi-header__image-card">
                                        <Image
                                            src="/images/business-analytics/power-bi/PBI Logo.svg"
                                            alt="simplify data - Power BI Entwicklung"
                                            width={256}
                                            height={256}
                                            style={{
                                                width: '100%',
                                                height: 'auto'
                                            }}
                                        />
                                    </div>
                                </FadeInAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default PowerBiHeader;
